import { TextField } from "@mui/material";
import React from "react";
import { SxProps } from "@mui/system";

type LoginTextFieldProps = {
    id: string;
    type: string;
    label: string;
    helperText?: string | JSX.Element;
    placeholder?: string;
    value: string | number;
    error?: boolean;
    onChangeHandler: Function;
    onInvalidHandler?: Function;
    InputProps?: Object;
    inputProps?: Object;
    required?: boolean;
    focused?: boolean;
};

const textFieldSx: SxProps = {
    "& .MuiFormHelperText-root": {
        marginLeft: "2px",
        fontSize: "15px",
        fontWeight: 400,
        marginTop: "8px",
        color: "primary.main",

        a: {
            color: 'inherit'
        }
    },

    ".MuiInputBase-root": {
        "&:before": {
            borderBottomWidth: 2,
            borderColor: "secondary.main",
        },

        backgroundColor: "white",

        "&:focus, &:hover": {
            backgroundColor: "white",
        }
    },

    ".MuiFilledInput-root": {
        '&:hover:not(.Mui-disabled, .Mui-error, .Mui-focused):before': {
            borderBottomWidth: 2,
            borderColor: "primary.main",
        }
    },

    input: {
        backgroundColor: "white",
        height: "24px",
        padding: "12px 18px",
    },

    "& .MuiFormLabel-root": {
        position: "static",
        marginBottom: 1,
        transform: 'none'
    }
};

const LoginTextField = ({
    id,
    type,
    label,
    helperText,
    placeholder,
    value,
    error,
    onChangeHandler,
    onInvalidHandler,
    InputProps,
    inputProps,
    required,
    focused=true
}: LoginTextFieldProps) => (
    <TextField
        autoFocus={focused}
        autoComplete="on"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
        margin="normal"
        variant="filled"
        fullWidth
        id={id}
        type={type}
        label={label}
        value={value}
        error={error}
        color="primary"
        size={"medium"}
        required={required}
        helperText={helperText}
        placeholder={placeholder}
        onChange={(ev) => {
            onChangeHandler(ev, ev.target.value);
        }}
        onInvalid={onInvalidHandler && onInvalidHandler()}
        InputLabelProps={{ shrink: true }}
        InputProps={InputProps}
        inputProps={inputProps}
        sx={textFieldSx}
    />
);

export default LoginTextField;
